const dateComparator = (date1: string, date2: string): number => {
    return new Date(date1) < new Date(date2) ? -1 : 1;
}

export default dateComparator;